











































import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { MUSIC_CREATE, MUSIC_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import MusicFilterModel from "@models/music/musicFilterModel";
import AlbumGetListResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AlbumGetListResponse";
import AudioFileAlbumCategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryResponse";
import TranslationModel from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/TranslationModel";

@Component
export default class PageMusicComponent extends Vue {
  @Inject('eventBus') eventBus: EventBus;
  filter: MusicFilterModel = new MusicFilterModel();
  columnNames = [
    '#',
    'Картинка',
    'Название',
    "Категории",
    'Платная',
    'Треков',
    'Сон',
    '',
    ''
  ];
  createRouteName = MUSIC_CREATE;
  editRouteName = MUSIC_EDIT;
  getDataFunc = this.$api.MusicService.getListAsync.bind(this.$api.MusicService);
  removeFunc = this.$api.MusicService.deleteAlbumAsync.bind(this.$api.MusicService);
  async created() {
  }
  async startDelete(item: AlbumGetListResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  getCategoryName(meditation: AlbumGetListResponse): string {
    const translations = meditation.Categories.reduce(
      (a: TranslationModel[], b: AudioFileAlbumCategoryResponse) => {
        return a.concat(b.Translations);
      },
      []
    );
    return translations.map((x) => `${x.LangCode}:${x.Name}`).join("\n");
  }
}
